import { AlreadyTranslated } from '@execonline-inc/translations';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AttributeResource } from '../../Types';

export interface Props {
  competency: AttributeResource;
}

const CompetencyLabel: React.FC<Props> = ({ competency }) =>
  competency.payload.name
    .map((name) => (
      <div
        className={clsx([
          'text-gray-900 border border-gray-900 break-keep inline-block rounded-md py-1',
          'px-2 text-xs font-medium tracking-tight',
        ])}
      >
        <AlreadyTranslated content={name} />
      </div>
    ))
    .getOrElse(() => <></>);

export default observer(CompetencyLabel);
